export const availableMethods = [
    'Update_Device',
    'Reset_Device',
    'Set_Debug_Status',
    'Order_Device_Reboot',
    'Recalibrate_Co2',
    'Delete_Device_Cache',
    'Dissociate_Module',
    'Set_Data_Offset',
    'Modify_Device_Behavior',
    'Toggle_Device_Dump',
    'Send_Vpn_Command',
    'Change_Heating_Algo',
    'Recompute_Heating_Algo',
    'Delete_Account',
    'Delete_Identity_Keys',
    'Generate_Qr_Code',,
    'Migrate_Data_2',
    'Write_Ssh',
    'Remove_User_From_Home',
    'Delete_Plant',
    'Delete_Eliot_User',
    'Read_Secret',,
    'Unlock_Network',
    'Move_Device_To_New_Temporary_Home',
    'Reset_Migration_Secret',
    'Reset_Migration_Flag',
    'Reset_Flag',
    'Associate_User',
    'Delete_Empty_Homes',
    'Modify_Group',
    'Create_Feature_Flag',
    'Create_Feature_Flag_Group',
    'Delete_Feature_Flag_Group',
    'Update_Feature_Flag',
    'Release_Feature_Flag',
    'Revert_Feature_Flag',
    'Delete_Feature_Flag',
    'Assign_Feature_Flag_To_User',
    'Remove_Feature_Flag_From_User',
    'Assign_Feature_Flag_To_Group',
    'Remove_Feature_Flag_From_Group',
    'Add_User_To_Feature_Flag_Group',
    'Remove_User_From_Feature_Flag_Group'
];

